import React from 'react';

export const HeartIcon = ({ liked }: { liked: boolean }) => {
  const fill = liked ? '#DB5769' : 'none';

  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 21C17.25 17.4525 22.5 13.5 22.5 8.25003C22.502 7.56004 22.3675 6.87646 22.1044 6.2386C21.8413 5.60075 21.4546 5.02121 20.9667 4.53331C20.4788 4.0454 19.8993 3.65877 19.2614 3.39563C18.6236 3.1325 17.94 2.99805 17.25 3.00003C15.9 3.00003 14.565 3.51003 13.5375 4.53753L12 6.07503L10.4625 4.53753C9.97599 4.04817 9.39754 3.65983 8.76041 3.39483C8.12328 3.12983 7.44004 2.99341 6.75 2.99341C6.05995 2.99341 5.37672 3.12983 4.73959 3.39483C4.10246 3.65983 3.524 4.04817 3.0375 4.53753C2.54934 5.02458 2.16221 5.60328 1.89836 6.24039C1.63451 6.87749 1.49913 7.56045 1.5 8.25003C1.5 13.5 6.75 17.4525 12 21Z'
        fill={fill}
        fillOpacity='0.8'
        stroke='white'
        strokeWidth='1'
      />
    </svg>
  );
};
